import store from '@/store';
import { roleInCurrentOrganisation } from './roleInMerchant';

// Fallback has been implemented.
// Consider joining this with UserPermissions.mixin during rewrite.

export default function hasPermissionInOrganisation(permission) {
  const userRoleInOrganisation = roleInCurrentOrganisation();

  if (
    store.getters['user/incognito'] ||
    userRoleInOrganisation === 'owner'
  ) {
    return true;
  }

  // take any member merchant for this since this is a org permission and all merchant have the same value
  const currentOrganisationId = store.getters['organisation/currentOrganisation'].id;
  const userOrganisationPermissions = store.getters['user/userPermissions'][currentOrganisationId];

  return (userOrganisationPermissions && userOrganisationPermissions.includes(permission));
}
